import { render, staticRenderFns } from "./mdc-tab-indicator.vue?vue&type=template&id=6b1c26fc&"
import script from "./mdc-tab-indicator.vue?vue&type=script&lang=ts&"
export * from "./mdc-tab-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-tab-indicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports